interface Props {
    sequenceNo: number;
    active?: boolean;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
    sm: 'h-6 min-w-6 text-xs',
    md: 'h-7 min-w-7 text-sm',
    lg: 'h-8 min-w-8 text-sm',
};

export const LevelBadge = ({sequenceNo, active, size = 'sm', className = ''}: Props) => (
    <span
        className={`inline-flex shrink-0 items-center justify-center rounded font-bold leading-none ${
            active
                ? 'bg-brand text-white'
                : 'border border-line bg-surface-muted text-ink-muted'
        } ${SIZE[size]} ${className}`}
    >
        L{sequenceNo}
    </span>
);
